
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"50","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Component 171"}},[_c('rect',{attrs:{"data-name":"Rectangle 10854","width":"50","height":"50","rx":"25","fill":"#245389"}}),_c('path',{attrs:{"data-name":"send (3)","d":"M17.331 17.099a1.1 1.1 0 00-.261 1.119l5.085 15.26a1.087 1.087 0 001.032.741h.024a1.081 1.081 0 001.024-.785l2.105-7.319 7.316-2.107a1.088 1.088 0 00.036-2.078l-15.256-5.085a1.058 1.058 0 00-1.105.254z","fill":"#fff"}})])])
          )
        }
      }
    